import { useState } from "react";
import { IoMenuSharp } from "react-icons/io5";
import {
  IoNotificationsOutline,
  IoChatbubbleOutline,
  IoExpandOutline,
  IoSearchOutline,
} from "react-icons/io5";
import { MdOutlineDarkMode, MdOutlineLightMode } from "react-icons/md";
import { FaChevronDown } from "react-icons/fa";
import "./LogoHeader.css";

const LogoHeader = ({ toggleSidebar }) => {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div id="logo-header">
      {/* LEFT SIDE */}
      <div className="web-logo">
        <button
          type="button"
          className="menu-icon-box"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <IoMenuSharp className="menu-icon-btn" />
        </button>

        <div className="header-search">
          <IoSearchOutline className="header-search-icon" />
          <input type="text" placeholder="Search..." />
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="header-box">
        <button
          type="button"
          className="header-icon"
          onClick={() => setDarkMode(!darkMode)}
          aria-label="Toggle dark mode"
        >
          {darkMode ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
        </button>

        <button type="button" className="header-icon" aria-label="Messages">
          <IoChatbubbleOutline />
        </button>

        <button
          type="button"
          className="header-icon notification"
          aria-label="Notifications"
        >
          <IoNotificationsOutline />
          <span className="notification-dot">4</span>
        </button>

        <button
          type="button"
          className="header-icon header-icon-hide-sm"
          aria-label="Fullscreen"
        >
          <IoExpandOutline />
        </button>

        <div className="header-divider" />

        <div className="profile-box">
          <img src="https://i.pravatar.cc/100" alt="profile" />
          <div className="profile-info">
            <span className="name">Admin</span>
            <span className="role">Super Admin</span>
          </div>
          <FaChevronDown className="profile-caret" />
        </div>
      </div>
    </div>
  );
};

export default LogoHeader;